import { render, staticRenderFns } from "./ModalConfirmacaoSair.vue?vue&type=template&id=bd14bace&"
import script from "./ModalConfirmacaoSair.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmacaoSair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports